module.exports = __webpack_public_path__ + "img/classhourRecord.50555f12.svg";